<template>
  <div class="content">
    <div class="main">
      <el-row type="flex">
        <el-col :span="8">
          <div class="main-left">
            <div class="left-item head" style="cursor: pointer" @click="goHome">
              <el-image :src="$domain.logo" fit="contain" />
            </div>
            <div class="left-item">
              <el-image
                :src="$common.getResourceUrl('pcweb/login/color.png')"
              />
              <div>
                <h3>学画</h3>
                <p>明星讲师深入指导</p>
              </div>
            </div>
            <div class="left-item">
              <el-image
                :src="$common.getResourceUrl('pcweb/login/order.png')"
              />
              <div>
                <h3>接单</h3>
                <p>助你轻松对接需求方</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col class="main-right" :span="16">
          <el-button class="changeType" plain @click="changeType">
            <icon-svg
              v-show="type == 'phone'"
              icon-class="erweima"
              style="font-size: 30px"
            />
            <icon-svg
              v-show="type == 'wechat'"
              icon-class="phone"
              style="font-size: 30px"
            />
          </el-button>
          <div v-show="type == 'phone'" class="main-form">
            <div class="type-phone">
              <h3>手机验证码 安全登录</h3>
              <el-form ref="form" :model="form">
                <el-form-item>
                  <el-input
                    v-model="form.phone"
                    class="phone-input"
                    clearable
                    placeholder="请输入手机号"
                    type="tel"
                  >
                    <el-select
                      v-model="countrySelectIndex"
                      class="country-select"
                      slot="prepend"
                      placeholder="请选择"
                      @change="countrySelectChange"
                    >
                      <el-option
                        v-for="(c, index) in countryList"
                        :key="index"
                        :label="`+${c.area_code}`"
                        :value="index"
                        >{{ c.name_cn }} +{{ c.area_code }}</el-option
                      >
                    </el-select>
                  </el-input>
                </el-form-item>
                <el-form-item v-if="usePassword">
                  <el-input
                    v-model="form.password"
                    class="yzm-input"
                    clearable
                    placeholder="请输入登录密码"
                    show-password
                    type="password"
                  />
                </el-form-item>
                <el-form-item v-else>
                  <el-input
                    v-model="form.code"
                    class="yzm-input"
                    clearable
                    oninput="if(value.length>4)value=value.slice(0,4)"
                    placeholder="请输入验证码"
                    type="number"
                  >
                    <el-button
                      slot="append"
                      class="yzm-buttom"
                      :disabled="yzmDisabled"
                      :loading="yzmLoading"
                      type="text"
                      @click="getYzm()"
                      >{{ yzmText }}</el-button
                    >
                  </el-input>
                </el-form-item>

                <el-form-item style="margin-bottom: 0">
                  <el-button class="btngo" type="primary" @click="goOnLogin()"
                    >立即登录</el-button
                  >
                </el-form-item>
                <div style="text-align: right">
                  <el-button type="text" @click="usePassword = !usePassword">{{
                    usePassword ? '短信验证码登录' : '使用密码登录'
                  }}</el-button>
                </div>
              </el-form>
            </div>
          </div>
          <div v-show="type == 'wechat'" class="main-form">
            <div class="type-phone">
              <h3 style="margin-bottom: 50px">微信扫码 安全登录</h3>
              <div id="wxlogin_container"></div>
            </div>
          </div>
          <div v-if="treatys.length > 0" class="xieyi">
            <el-checkbox v-model="checked" class="checked" />
            <span class="text">
              <span>我已阅读并同意</span>
              <span v-for="(i, k) in treatys" :key="k">
                {{ k === treatys.length - 1 ? '及' : '' }}
                <a class="link" @click="openUrl(i.page.path)"
                  >《{{ i.name }}》</a
                >
              </span>
            </span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getCountryList } from '@/network/request'
import { getPageData, goLogin, getYzm } from '@/network/request'
export default {
  name: 'Login',
  components: {},
  props: {},
  data() {
    return {
      countrySelectIndex: 0,
      countryList: [],
      treatys: [],
      type: 'phone',
      // 表单内数据
      wechatToken: '',
      usePassword: false,
      form: {
        country: 'CN',
        pre: '+86',
        phone: '',
        password: '',
        code: '',
      },
      // 获取验证码
      yzmDisabled: false,
      yzmLoading: false,
      yzmText: '获取验证码',
      // 返回刚才跳转过来的路由地址
      url: this.$route.query.url || '/',
      checked: false, // 复选框控制
    }
  },
  computed: {
    formatPhone() {
      return this.form.phone ? `${this.form.pre}${this.form.phone}` : ''
    },
  },
  watch: {},
  created() {
    getPageData({ alias: 'LOGIN' }).then((res) => {
      this.treatys = res.data.result.params.treatys || []
    })
    this.loadCountryList()
  },
  mounted() {
    window.changeType = this.changeType
    window.setWechatToken = this.setWechatToken
    window.loginSuccess = this.loginSuccess

    this.loadWxLoginHandel()
  },
  beforeDestroy() {
    delete window.changeType
    delete window.setWechatToken
    delete window.loginSuccess
  },
  methods: {
    goHome() {
      this.$router.push('/')
    },
    // 获取国家列表
    async loadCountryList() {
      // 如果本地存储中有职业列表，则不走接口
      if (localStorage.getItem('option-countries')) {
        this.countryList = JSON.parse(localStorage.getItem('option-countries'))
      } else {
        const res = await getCountryList()
        // console.log(res.data.result)
        this.countryList = res.data.result
        localStorage.setItem(
          'option-countries',
          JSON.stringify(res.data.result)
        )
      }
    },
    // 国家选择器切换
    countrySelectChange(index) {
      let item = this.countryList[index]
      this.form.country = item.code
      this.form.pre = `+${item.area_code}`
    },
    loadWxLoginHandel() {
      this.$nextTick(() => {
        /* eslint-disable */
        const redirect_uri =
          'https://server.wenqing123.com/notice/oauth/wechat/back/pc'
        const backurl = this.$common.getlocalBaseUrl() + '/wxback'
        const userToken = localStorage.getItem('user-token') || ''
        new WxLogin({
          self_redirect: true,
          id: 'wxlogin_container',
          appid: 'wxb7da7912740a8270',
          scope: 'snsapi_login',
          redirect_uri: encodeURIComponent(
            `${redirect_uri}?&backurl=${backurl}&user_token=${userToken}`
          ),
          state: '',
          style: 'black',
          href: this.$common.getResourceUrl('pcweb/wx-login-style.css'),
        })
        /* eslint-disable */
      })
    },
    setWechatToken(wechatToken) {
      this.wechatToken = wechatToken
    },
    openUrl(url) {
      window.open(url)
    },
    changeType() {
      this.type = this.type === 'phone' ? 'wechat' : 'phone'
    },
    // 获取验证码
    async getYzm() {
      let phone = this.formatPhone
      if (!phone) {
        this.$message('请输入手机号')
        return false
      }

      this.yzmLoading = true
      this.yzmText = '正在发送'
      const res = await getYzm({ phone, country: this.form.country }).catch(
        (e) => {
          // 频繁时会携带剩余秒数返回
          this.setTime(e.data.code === 20001 ? e.data.result.surplus : 0)
        }
      )
      this.yzmLoading = false
      this.setTime(res ? res.data.result.surplus || 0 : 0)
    },
    // 获取验证码倒计时
    setTime(time) {
      if (time > 0) {
        this.yzmDisabled = true
        this.yzmText = time + ' s'
        const sendTimer = setInterval(() => {
          time--
          if (time <= 0) {
            this.yzmDisabled = false
            this.yzmText = '重新获取'
            clearInterval(sendTimer)
          } else {
            this.yzmText = time + ' s'
          }
        }, 1000)
      } else {
        this.yzmDisabled = false
        this.yzmText = '重新获取'
      }
    },
    // 登录接口
    async goOnLogin() {
      if (this.checked) {
        let phone = this.formatPhone
        if (!phone) {
          this.$message('请输入手机号')
          return false
        }
        const formData = { phone, country: this.form.country }
        if (this.usePassword) {
          if (!this.form.password) {
            this.$message('请输入登录密码')
            return false
          } else {
            formData.password = this.form.password
          }
        } else {
          if (!this.form.code) {
            this.$message('请输入短信验证码')
            return false
          } else {
            formData.code = this.form.code
          }
        }
        await goLogin({ wechatToken: this.wechatToken, ...formData })
        this.loginSuccess()
      } else {
        this.$message.error('请阅读并同意用户服务协议及隐私政策')
      }
    },
    loginSuccess() {
      this.$store.dispatch('setUser')
      // 登陆成功
      this.$router.replace(decodeURIComponent(this.url))
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: #49b7f3;
  padding-bottom: 100px;

  .bottom {
    position: fixed;
    bottom: 0;
    text-align: center;
    min-height: 80px;
    font-size: 14px;
    line-height: 24px;
    color: rgba(153, 153, 153, 0.8);
  }

  .main {
    width: 791px;
    height: 560px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background-color: #fff;
    overflow: hidden;
    > .el-row {
      height: 100%;
      > .el-col {
        height: 100%;
      }
    }

    .main-left {
      width: 100%;
      height: 100%;
      background-color: rgba(73, 183, 243, 0.05);
      padding: 90px 40px 40px 40px;
      .left-item {
        display: flex;
        align-items: center;
        margin-bottom: 50px;

        .el-image {
          display: block;
          width: 30px;
          height: 30px;
          margin-right: 14px;
          border-radius: 5px;
          margin-left: 12px;
        }
        h3 {
          font-size: 15px;
          color: #797e87;
          margin-bottom: 4px;
        }
        p {
          font-size: 14px;
          color: #797e87;
        }
        &.head {
          margin-bottom: 90px;
          .el-image {
            width: 100%;
            height: 46px;
            border-radius: 10px;
            margin-left: 10px;
          }
          h3 {
            font-size: 18px;
            color: #272c38;
            margin-bottom: 10px;
          }
        }
      }
    }
    .main-right {
      position: relative;
      padding-top: 40px;
      .main-form {
        padding: 0 40px;
        height: calc(100% - 50px);

        .el-form-item {
          margin-bottom: 30px;
        }
      }
      .changeType {
        position: absolute;
        right: 0;
        top: 0;
        border: 0;
      }
    }

    .type-phone {
      padding: 40px 40px;
      h3 {
        text-align: center;
        font-size: 22px;
        color: #333333;
        margin-bottom: 60px;
      }

      ::v-deep(.el-form) {
        .el-input__inner {
          width: 100%;
          height: 52px;
          font-size: 14px;
          &::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
        }

        .yzm-input {
          .el-input-group__append {
            background: #fff;
            .yzm-buttom {
              display: block;
              width: 120px;
              height: 52px;
              color: #37a6ff;
              font-size: 14px;
            }
          }
        }
        .btngo {
          margin-top: 8px;
          width: 100%;
          height: 55px;
          border-radius: 8px;
          font-size: 18px;
          background-color: #49b7f3;
          outline: none;
          border: none;
        }
        .btngo:hover {
          opacity: 0.8;
        }
      }
    }

    .xieyi {
      text-align: center;
      line-height: 50px;
      .text {
        font-size: 12px;
        margin-left: 10px;
        color: #999999;
        .link {
          color: #37a6ff;
          cursor: pointer;
        }
      }
    }
  }
}
#wxlogin_container {
  text-align: center;
  height: 320px;
  overflow: hidden;
}

.phone-input {
  ::v-deep {
    .el-input-group__prepend {
      background: none;
      .country-select {
        width: 84px;

        .el-input__inner {
          // font-weight: 600;
          text-align: center;
          font-size: 15px !important;
        }
      }
    }
  }
}
</style>
